<template>
    <div class="block">
      <p class="description" v-html="product.description"></p>
    </div>
</template>

<script>
    export default {
      name: "product-description",
      props: {
        product: null
      }
    }
</script>

<style scoped>
  .block {
    padding: 20px;
  }
   .description {
    color: #000;
    font-size: 16px;
  }
</style>
